let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("58UdM"), load("aLgYQ"), load("4Qstt")]).then(() => parcelRequire('knzfV'));